import './App.css';
import "./bootstrap.min.css"
import Home from "./screens/home"
import About from "./screens/about"
import Services from './screens/services';
import AccountingFinance from './screens/accountingfinance';
import News from './screens/news';
import InnerNews from './screens/IdvBlog';
import Contact from './screens/contact';
import LoginScreen from "./AdminScreens/LoginScreen";
import BlogsScreen from "./AdminScreens/BlogsScreens/BlogsScreen";
import AdminScreen from "./AdminScreens/AdminScreen";
import { Routes, Route } from 'react-router-dom';
import Footer from "./components/Footer/Footer"
import IndustriesExpertise from './screens/IndustriesExpertise';
import AccountingTaxes from './screens/AccountingTaxes';
import OutsourcedServices from './screens/OutsourcedServices';
import ConsultingServices from './screens/ConsultingServices';
import ThankYou from './screens/thankyou';
import NotFound from './screens/NotFound';
import PrivacyPolicy from './screens/PrivacyPolicy';
import TermsServices from './screens/TermsServices';



function App() {
  return (
    <>
      <Routes>
      <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/accounting-taxes" element={<AccountingTaxes />} />
        <Route path="/industry-expertise" element={<IndustriesExpertise />} />
        <Route path="/accountingfinance" element={<AccountingFinance />} />
        <Route path="/outsourced-services" element={<OutsourcedServices />} />
        <Route path="/consulting-services" element={<ConsultingServices />} />
        {/* <Route path="/news" element={<News />} /> */}
        <Route path="/contact" element={<Contact />} />
        <Route path="/thank-you-contact" element={<ThankYou />} />
        <Route path="/thank-you-meeting/" element={<ThankYou />} />
        <Route path="/thank-you-meeting/:id" element={<ThankYou />} />
        <Route path="/thank-you-subscribe" element={<ThankYou type="subscription"/>} />
        
        <Route path="/admin" element={<AdminScreen />} />
        <Route path="/admin/blogs" element={<BlogsScreen />} />
        <Route path="/blogs/:id" element={<InnerNews />} />
        <Route path="/login" element={<LoginScreen />} />

        
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-services" element={<TermsServices />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer/>
    </>
  );
}

export default App;
